import React, { useState } from 'react';
import { Icon, Image } from '@chakra-ui/react';
import { LuGlobe } from 'react-icons/lu';

const FAVICON_BOX_SIZE = 4;

interface ChatResponseWebSourceFaviconProps {
	/** Resolved icon URL, or null when the source has no usable domain. */
	src: string | null;
}

/**
 * The icon service has no entry for plenty of domains, so the globe fallback keeps a miss looking
 * deliberate. Tracking which src failed rather than a boolean means a new src is retried without an
 * effect to reset the flag.
 */
const ChatResponseWebSourceFavicon: React.FC<ChatResponseWebSourceFaviconProps> = (
	props: ChatResponseWebSourceFaviconProps,
) => {
	const { src } = props;
	const [failedSrc, setFailedSrc] = useState<string | null>(null);
	const showFallback = src === null || failedSrc === src;

	if (showFallback) {
		return <Icon as={LuGlobe} boxSize={FAVICON_BOX_SIZE} color="fg.muted" mt={0.5} flexShrink={0} />;
	}

	return (
		<Image
			data-testid="web-source-favicon"
			src={src}
			alt=""
			boxSize={FAVICON_BOX_SIZE}
			mt={0.5}
			flexShrink={0}
			borderRadius="sm"
			loading="lazy"
			referrerPolicy="no-referrer"
			onError={() => setFailedSrc(src)}
		/>
	);
};

export default ChatResponseWebSourceFavicon;
